module.exports = __webpack_public_path__ + "img/leftTime2.ae080b97.png";